import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './components/CtaButton';
import { SectionDivider } from './components/SectionDivider';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
const fadeInUp = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: 'easeOut'
    }
  }
};
const staggerContainer = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
export function App() {
  return <div className="min-h-screen bg-mystic-black text-mystic-ivory selection:bg-mystic-gold selection:text-mystic-black" data-id="element-0">
      {/* 🟣 HERO SECTION */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20 pb-16 lg:pt-0 lg:pb-0" data-id="element-1">
        {/* Background Image with Overlay */}
        <div className="absolute inset-0 z-0" data-id="element-2">
          <motion.div className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-40 lg:opacity-60" style={{
          backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/jHNxvQUoJEs3rLwpr4EkkR/ChatGPT_Image_16_may_2026,_13_40_59.png)'
        }} initial={{
          scale: 1.1
        }} animate={{
          scale: 1
        }} transition={{
          duration: 20,
          ease: 'easeOut'
        }} data-id="element-3" />
          <div className="absolute inset-0 bg-gradient-to-b from-mystic-black/80 via-mystic-black/60 to-mystic-black lg:bg-gradient-to-r lg:from-mystic-black lg:via-mystic-black/80 lg:to-transparent" data-id="element-4"></div>
        </div>

        <div className="container mx-auto px-6 relative z-10" data-id="element-5">
          <div className="max-w-3xl lg:w-1/2 lg:pr-12" data-id="element-6">
            <motion.div initial="hidden" animate="visible" variants={staggerContainer} data-id="element-7">
              <motion.p variants={fadeInUp} className="text-mystic-gold text-sm md:text-base tracking-[0.2em] uppercase mb-6 font-semibold" data-id="element-8">
                Tarotista Internacional • Parapsicólogo • Guía Espiritual
              </motion.p>

              <motion.h1 variants={fadeInUp} className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight mb-8 text-gradient-gold" data-id="element-9">
                Las cartas del Tarot muchas veces revelan emociones que llevas
                tiempo intentando entender.
              </motion.h1>

              <motion.div variants={fadeInUp} className="mb-8 text-xl md:text-2xl text-mystic-ivorymuted leading-relaxed" data-id="element-10">
                <p className="mb-6" data-id="element-11">
                  Si llegaste hasta aquí, probablemente estás atravesando:
                </p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" data-id="element-12">
                  <div className="flex items-center gap-3 bg-mystic-dark/50 border border-mystic-gold/20 p-4 rounded-sm backdrop-blur-sm" data-id="element-13">
                    <span className="text-xl" data-id="element-14">💔</span>
                    <span data-id="element-15">desgaste emocional</span>
                  </div>
                  <div className="flex items-center gap-3 bg-mystic-dark/50 border border-mystic-gold/20 p-4 rounded-sm backdrop-blur-sm" data-id="element-16">
                    <span className="text-xl" data-id="element-17">😔</span>
                    <span data-id="element-18">ansiedad sentimental</span>
                  </div>
                  <div className="flex items-center gap-3 bg-mystic-dark/50 border border-mystic-gold/20 p-4 rounded-sm backdrop-blur-sm" data-id="element-19">
                    <span className="text-xl" data-id="element-20">💸</span>
                    <span data-id="element-21">preocupación constante</span>
                  </div>
                  <div className="flex items-center gap-3 bg-mystic-dark/50 border border-mystic-gold/20 p-4 rounded-sm backdrop-blur-sm" data-id="element-22">
                    <span className="text-xl" data-id="element-23">🌑</span>
                    <span data-id="element-24">agotamiento energético</span>
                  </div>
                </div>

                <p className="mb-6 italic text-mystic-ivory" data-id="element-25">
                  Y aunque intentas mantenerte fuerte… por dentro sigues
                  sintiendo dudas, presión y cansancio emocional.
                </p>

                <p className="mb-6" data-id="element-26">
                  <span className="mr-2" data-id="element-27">🔮</span> A través de una orientación
                  espiritual personalizada y la interpretación consciente de las
                  cartas del Tarot, Salomón Rey del Amor te acompaña a
                  comprender mejor tus emociones, relaciones, energía y
                  decisiones personales.
                </p>

                <p className="mb-10" data-id="element-28">
                  <span className="mr-2" data-id="element-29">✨</span> Este espacio está diseñado
                  para personas que decidieron comenzar un verdadero proceso de
                  claridad, transformación interior y conexión espiritual.
                </p>
              </motion.div>

              <motion.div variants={fadeInUp} data-id="element-30">
                <CtaButton text="QUIERO RECIBIR MI LECTURA DEL TAROT" data-id="element-31" />
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>

      <SectionDivider data-id="element-32" />

      {/* 🟣 SECCIÓN IDENTIFICACIÓN */}
      <section className="py-20 relative bg-mystic-pattern" data-id="element-33">
        <div className="container mx-auto px-6 max-w-4xl text-center" data-id="element-34">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} variants={staggerContainer} data-id="element-35">
            <motion.h2 variants={fadeInUp} className="text-4xl md:text-5xl lg:text-6xl font-bold mb-10 text-mystic-gold" data-id="element-36">
              Tu mente quiere respuestas… y tu energía lleva tiempo pidiendo
              claridad.
            </motion.h2>

            <motion.div variants={fadeInUp} className="text-xl md:text-2xl text-mystic-ivorymuted space-y-6 mb-12" data-id="element-37">
              <p data-id="element-38">
                Has intentado distraerte. Has querido resolver tus emociones
                solo/a. Has tratado de seguir adelante.
              </p>

              <p data-id="element-39">Pero cada día vuelves a sentir:</p>

              <div className="flex flex-wrap justify-center gap-4 py-4" data-id="element-40">
                <span className="px-5 py-2 border border-mystic-burgundy bg-mystic-dark rounded-full text-sm tracking-wide" data-id="element-41">
                  💭 pensamientos repetitivos
                </span>
                <span className="px-5 py-2 border border-mystic-burgundy bg-mystic-dark rounded-full text-sm tracking-wide" data-id="element-42">
                  💔 vacío emocional
                </span>
                <span className="px-5 py-2 border border-mystic-burgundy bg-mystic-dark rounded-full text-sm tracking-wide" data-id="element-43">
                  😔 desgaste mental
                </span>
                <span className="px-5 py-2 border border-mystic-burgundy bg-mystic-dark rounded-full text-sm tracking-wide" data-id="element-44">
                  🌑 sensación de bloqueo
                </span>
              </div>

              <p className="mt-8" data-id="element-45">
                <span className="mr-2" data-id="element-46">🔮</span> Muchas veces el Tarot no llega
                para predecir tu vida… Llega para ayudarte a comprender lo que
                emocionalmente ya no puedes seguir ignorando.
              </p>

              <p data-id="element-47">
                Porque sanar también requiere atención, dirección y la decisión
                de invertir en tu bienestar emocional y espiritual.
              </p>

              <p className="text-mystic-gold font-medium text-2xl mt-8" data-id="element-48">
                <span className="mr-2" data-id="element-49">✨</span> Una transformación verdadera
                comienza cuando decides escucharte y darte el valor que mereces.
              </p>
            </motion.div>

            <motion.div variants={fadeInUp} data-id="element-50">
              <CtaButton text="QUIERO RECIBIR ORIENTACIÓN" variant="outline" data-id="element-51" />
            </motion.div>
          </motion.div>
        </div>
      </section>

      <SectionDivider data-id="element-52" />

      {/* 🟣 ÁREA 1 — SALUD EMOCIONAL */}
      <section className="py-20 relative" data-id="element-53">
        <div className="container mx-auto px-6" data-id="element-54">
          <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-55">
            <motion.div className="w-full lg:w-1/2 relative" initial={{
            opacity: 0,
            x: -50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-56">
              <div className="absolute -inset-4 border border-mystic-gold/30 rounded-sm z-0 translate-x-4 translate-y-4" data-id="element-57"></div>
              <img src="https://cdn.magicpatterns.com/uploads/gWWFJGuw16XdQtnda61BjA/ChatGPT_Image_16_may_2026,_13_44_03.png" alt="Mujer leyendo el tarot" className="relative z-10 w-full h-auto rounded-sm shadow-2xl shadow-mystic-black" data-id="element-58" />
            </motion.div>

            <motion.div className="w-full lg:w-1/2" initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={staggerContainer} data-id="element-59">
              <motion.h2 variants={fadeInUp} className="text-4xl md:text-5xl font-bold mb-8 text-mystic-gold" data-id="element-60">
                Las cartas del Tarot también pueden ayudarte a entender tu
                estado emocional.
              </motion.h2>

              <motion.div variants={fadeInUp} className="text-xl text-mystic-ivorymuted space-y-6 mb-10" data-id="element-61">
                <p data-id="element-62">
                  Cuando el cansancio emocional se acumula, comienzas a perder
                  tranquilidad, claridad y motivación.
                </p>
                <p className="italic text-mystic-ivory" data-id="element-63">
                  Te cuesta descansar. Piensas demasiado. Tu energía se siente
                  pesada.
                </p>
                <p data-id="element-64">
                  <span className="mr-2" data-id="element-65">🔮</span> A través de una lectura
                  consciente del Tarot, trabajamos desde la introspección
                  emocional y el equilibrio energético para ayudarte a observar
                  tu situación desde una perspectiva más clara y profunda.
                </p>
                <p data-id="element-66">
                  <span className="mr-2" data-id="element-67">✨</span> Porque sentirte mejor no
                  sucede por casualidad. Sucede cuando decides iniciar un
                  proceso consciente de atención personal y transformación
                  interior.
                </p>
              </motion.div>

              <motion.div variants={fadeInUp} data-id="element-68">
                <CtaButton text="QUIERO RECUPERAR MI PAZ" data-id="element-69" />
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* 🟣 ÁREA 2 — AMOR Y RELACIONES */}
      <section className="py-24 relative bg-mystic-dark" data-id="element-70">
        <div className="container mx-auto px-6" data-id="element-71">
          <div className="flex flex-col lg:flex-row-reverse items-center gap-16" data-id="element-72">
            <motion.div className="w-full lg:w-1/2 relative" initial={{
            opacity: 0,
            x: 50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-73">
              <div className="absolute -inset-4 border border-mystic-gold/30 rounded-sm z-0 -translate-x-4 translate-y-4" data-id="element-74"></div>
              <img src="https://cdn.magicpatterns.com/uploads/p8bxQMUxJumgnRHEEbAsy3/ChatGPT_Image_16_may_2026,_13_46_08.png" alt="Pareja en consulta espiritual" className="relative z-10 w-full h-auto rounded-sm shadow-2xl shadow-mystic-black" data-id="element-75" />
            </motion.div>

            <motion.div className="w-full lg:w-1/2" initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={staggerContainer} data-id="element-76">
              <motion.h2 variants={fadeInUp} className="text-4xl md:text-5xl font-bold mb-8 text-mystic-gold" data-id="element-77">
                El Tarot puede ayudarte a comprender mejor lo que sucede en tus
                relaciones.
              </motion.h2>

              <motion.div variants={fadeInUp} className="text-xl text-mystic-ivorymuted space-y-6 mb-10" data-id="element-78">
                <p data-id="element-79">Las relaciones desgastan emocionalmente cuando:</p>
                <ul className="space-y-3 pl-4 border-l border-mystic-burgundy" data-id="element-80">
                  <li className="flex items-center gap-3" data-id="element-81">
                    <span className="text-xl" data-id="element-82">💔</span> existe distancia
                    afectiva
                  </li>
                  <li className="flex items-center gap-3" data-id="element-83">
                    <span className="text-xl" data-id="element-84">💭</span> dudas constantes
                  </li>
                  <li className="flex items-center gap-3" data-id="element-85">
                    <span className="text-xl" data-id="element-86">😔</span> discusiones repetidas
                  </li>
                  <li className="flex items-center gap-3" data-id="element-87">
                    <span className="text-xl" data-id="element-88">🌑</span> dependencia emocional
                  </li>
                </ul>
                <p className="mt-6" data-id="element-89">
                  <span className="mr-2" data-id="element-90">🔮</span> Muchas personas siguen
                  sufriendo porque no logran entender sus emociones ni la
                  dinámica energética que viven dentro de sus relaciones.
                </p>
                <p data-id="element-91">
                  A través de la orientación espiritual y las cartas del Tarot,
                  podrás observar tu situación sentimental desde una mirada más
                  consciente, emocional y reflexiva.
                </p>
                <p className="text-xl text-mystic-ivory mt-4" data-id="element-92">
                  <span className="mr-2" data-id="element-93">✨</span> Porque una relación sana
                  también comienza cuando decides trabajar en ti.
                </p>
              </motion.div>

              <motion.div variants={fadeInUp} data-id="element-94">
                <CtaButton text="QUIERO CLARIDAD EN MI RELACIÓN" variant="outline" data-id="element-95" />
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* 🟣 ÁREA 3 — DINERO Y PROSPERIDAD */}
      <section className="py-20 relative" data-id="element-96">
        <div className="container mx-auto px-6" data-id="element-97">
          <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-98">
            <motion.div className="w-full lg:w-1/2 relative" initial={{
            opacity: 0,
            x: -50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-99">
              <div className="absolute -inset-4 border border-mystic-gold/30 rounded-sm z-0 translate-x-4 translate-y-4" data-id="element-100"></div>
              <img src="https://cdn.magicpatterns.com/uploads/dQeqf6Zkaxoz4JA71b6GTf/ChatGPT_Image_16_may_2026,_13_58_26.png" alt="Altar de prosperidad y tarot" className="relative z-10 w-full h-auto rounded-sm shadow-2xl shadow-mystic-black" data-id="element-101" />
            </motion.div>

            <motion.div className="w-full lg:w-1/2" initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={staggerContainer} data-id="element-102">
              <motion.h2 variants={fadeInUp} className="text-4xl md:text-5xl font-bold mb-8 text-mystic-gold" data-id="element-103">
                Tu relación con la prosperidad también refleja tu estado
                interior.
              </motion.h2>

              <motion.div variants={fadeInUp} className="text-xl text-mystic-ivorymuted space-y-6 mb-10" data-id="element-104">
                <p className="italic text-mystic-ivory" data-id="element-105">
                  Trabajas. Te esfuerzas. Intentas avanzar.
                </p>
                <p data-id="element-106">Pero internamente sigues sintiendo:</p>
                <div className="grid grid-cols-2 gap-4" data-id="element-107">
                  <div className="bg-mystic-dark p-3 rounded border border-mystic-gold/10 flex items-center gap-2" data-id="element-108">
                    <span className="text-xl" data-id="element-109">💸</span> presión constante
                  </div>
                  <div className="bg-mystic-dark p-3 rounded border border-mystic-gold/10 flex items-center gap-2" data-id="element-110">
                    <span className="text-xl" data-id="element-111">😔</span> agotamiento emocional
                  </div>
                  <div className="bg-mystic-dark p-3 rounded border border-mystic-gold/10 flex items-center gap-2" data-id="element-112">
                    <span className="text-xl" data-id="element-113">💭</span> miedo al futuro
                  </div>
                  <div className="bg-mystic-dark p-3 rounded border border-mystic-gold/10 flex items-center gap-2" data-id="element-114">
                    <span className="text-xl" data-id="element-115">🌑</span> sensación de
                    estancamiento
                  </div>
                </div>
                <p className="mt-6" data-id="element-116">
                  <span className="mr-2" data-id="element-117">🔮</span> Las cartas del Tarot pueden
                  ayudarte a reflexionar sobre patrones emocionales y decisiones
                  personales relacionadas con tu bienestar y abundancia.
                </p>
                <p data-id="element-118">
                  <span className="mr-2" data-id="element-119">✨</span> Porque la prosperidad también
                  requiere claridad mental, equilibrio emocional y compromiso
                  contigo mismo/a.
                </p>
                <p className="text-xl text-mystic-ivory" data-id="element-120">
                  Una transformación consciente comienza cuando decides trabajar
                  en tu energía interior.
                </p>
              </motion.div>

              <motion.div variants={fadeInUp} data-id="element-121">
                <CtaButton text="QUIERO ABRIR MI CAMINO" data-id="element-122" />
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* 🟣 ÁREA 4 — ESPIRITUALIDAD Y ENERGÍA */}
      <section className="py-24 relative bg-mystic-dark" data-id="element-123">
        <div className="container mx-auto px-6" data-id="element-124">
          <div className="flex flex-col lg:flex-row-reverse items-center gap-16" data-id="element-125">
            <motion.div className="w-full lg:w-1/2 relative" initial={{
            opacity: 0,
            x: 50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-126">
              <div className="absolute -inset-4 border border-mystic-gold/30 rounded-sm z-0 -translate-x-4 translate-y-4" data-id="element-127"></div>
              <img src="https://cdn.magicpatterns.com/uploads/n9Kjjm6dEej4ZcQHEbRQTW/ChatGPT_Image_16_may_2026,_14_23_47.png" alt="Conexión energética espiritual" className="relative z-10 w-full h-auto rounded-sm shadow-2xl shadow-mystic-black" data-id="element-128" />
            </motion.div>

            <motion.div className="w-full lg:w-1/2" initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={staggerContainer} data-id="element-129">
              <motion.h2 variants={fadeInUp} className="text-4xl md:text-5xl font-bold mb-8 text-mystic-gold" data-id="element-130">
                Tu energía espiritual influye más de lo que imaginas.
              </motion.h2>

              <motion.div variants={fadeInUp} className="text-xl text-mystic-ivorymuted space-y-6 mb-10" data-id="element-131">
                <p data-id="element-132">
                  Cuando tu energía emocional y espiritual se desgasta,
                  comienzas a sentir:
                </p>
                <ul className="space-y-3 pl-4 border-l border-mystic-burgundy" data-id="element-133">
                  <li className="flex items-center gap-3" data-id="element-134">
                    <span className="text-xl" data-id="element-135">🌑</span> cansancio constante
                  </li>
                  <li className="flex items-center gap-3" data-id="element-136">
                    <span className="text-xl" data-id="element-137">💭</span> confusión mental
                  </li>
                  <li className="flex items-center gap-3" data-id="element-138">
                    <span className="text-xl" data-id="element-139">😔</span> desconexión emocional
                  </li>
                  <li className="flex items-center gap-3" data-id="element-140">
                    <span className="text-xl" data-id="element-141">🕯️</span> falta de dirección
                  </li>
                </ul>
                <p className="mt-6" data-id="element-142">
                  <span className="mr-2" data-id="element-143">🔮</span> A través de herramientas de
                  orientación espiritual, lectura del Tarot y acompañamiento
                  consciente, podrás iniciar un proceso de claridad interior y
                  reconexión energética.
                </p>
                <p data-id="element-144">
                  <span className="mr-2" data-id="element-145">✨</span> Porque transformar tu vida no
                  significa esperar respuestas mágicas.
                </p>
                <p className="text-xl text-mystic-ivory" data-id="element-146">
                  Significa tomar la decisión de trabajar en ti, comprender tus
                  emociones y permitirte evolucionar espiritualmente.
                </p>
              </motion.div>

              <motion.div variants={fadeInUp} data-id="element-147">
                <CtaButton text="QUIERO RECIBIR MI LECTURA" variant="outline" data-id="element-148" />
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>

      <SectionDivider data-id="element-149" />

      {/* 🟣 SOBRE SALOMÓN */}
      <section className="py-20 relative bg-mystic-pattern" data-id="element-150">
        <div className="container mx-auto px-6" data-id="element-151">
          <div className="flex flex-col lg:flex-row items-center gap-16 max-w-6xl mx-auto" data-id="element-152">
            <motion.div className="w-full lg:w-1/2 relative" initial={{
            opacity: 0,
            x: -50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-153">
              <div className="absolute -inset-4 border border-mystic-gold/30 rounded-sm z-0 translate-x-4 translate-y-4" data-id="element-154"></div>
              <img src="https://cdn.magicpatterns.com/uploads/uwsDoAFhkbFd8AJxXU2vLD/ChatGPT_Image_16_may_2026,_13_40_59.png" alt="Salomón Rey del Amor — Tarotista Internacional" className="relative z-10 w-full h-auto rounded-sm shadow-2xl shadow-mystic-black" data-id="element-155" />
            </motion.div>

            <motion.div className="w-full lg:w-1/2" initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={staggerContainer} data-id="element-156">
              <motion.p variants={fadeInUp} className="text-mystic-gold text-sm tracking-[0.2em] uppercase mb-4 font-semibold" data-id="element-157">
                Sobre el Maestro
              </motion.p>
              <motion.h2 variants={fadeInUp} className="text-4xl md:text-5xl font-bold mb-10 text-mystic-gold" data-id="element-158">
                Conoce a Salomón Rey del Amor
              </motion.h2>

              <motion.div variants={fadeInUp} className="text-xl md:text-2xl text-mystic-ivorymuted space-y-6" data-id="element-159">
                <p data-id="element-160">
                  <span className="mr-2" data-id="element-161">🔮</span>{' '}
                  <strong className="text-mystic-ivory" data-id="element-162">
                    Salomón Rey del Amor
                  </strong>{' '}
                  es tarotista internacional, parapsicólogo y guía espiritual.
                </p>

                <p data-id="element-163">
                  Durante años ha acompañado a personas que buscan claridad
                  emocional, orientación sentimental y equilibrio espiritual a
                  través de la interpretación consciente de las cartas del Tarot
                  y herramientas de introspección energética.
                </p>

                <p className="text-xl text-mystic-ivory font-medium pt-2" data-id="element-164">
                  <span className="mr-2" data-id="element-165">✨</span> Su enfoque está dirigido a
                  personas que desean comprender mejor su vida emocional y
                  comenzar un verdadero proceso de transformación interior.
                </p>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* 🟣 TESTIMONIOS */}
      <section className="py-24 relative" data-id="element-166">
        <div className="container mx-auto px-6 max-w-6xl" data-id="element-167">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold mb-16 text-center text-mystic-gold" data-id="element-168">
            Personas que decidieron escucharse y comenzar su proceso.
          </motion.h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-169">
            {[{
            name: 'Mariana R.',
            image: 'https://cdn.magicpatterns.com/uploads/naCMSXPmeoAyKWrDouc6ch/ChatGPT_Image_16_may_2026,_14_38_17.png',
            paragraphs: ['Llegué sintiéndome emocionalmente agotada y con demasiadas dudas en mi mente. La orientación con Salomón me ayudó a comprender emociones que llevaba guardando desde hace mucho tiempo.', 'Después de la consulta sentí tranquilidad, claridad y más seguridad para tomar decisiones importantes en mi vida.']
          }, {
            name: 'Carolina M.',
            image: 'https://cdn.magicpatterns.com/uploads/ve1nbNLsPyYEKCfZWiTN6D/ChatGPT_Image_16_may_2026,_14_39_42.png',
            paragraphs: ['La lectura del Tarot me permitió mirar mi relación desde otra perspectiva. Había demasiada confusión emocional y sentía desgaste constante.', 'La consulta me ayudó a entender muchas situaciones que no lograba comprender y hoy me siento emocionalmente más tranquila y consciente.']
          }, {
            name: 'Daniel A.',
            image: 'https://cdn.magicpatterns.com/uploads/o3NcjepoVrsE9PXUPrrFn4/ChatGPT_Image_16_may_2026,_14_40_54.png',
            paragraphs: ['Sentía un agotamiento constante y una sensación de estancamiento que no sabía cómo manejar. La orientación espiritual me ayudó a reconectarme conmigo mismo y empezar a organizar mejor mi energía y mis decisiones.', 'Fue una experiencia profunda que me dejó mucha claridad y tranquilidad interior.']
          }].map((t, idx) => <motion.div key={t.name} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: idx * 0.15
          }} className="relative bg-mystic-dark p-10 md:p-12 rounded-sm border border-mystic-gold/30" data-id="element-170">
                {/* Decorative corners */}
                <div className="absolute top-0 left-0 w-5 h-5 border-t-2 border-l-2 border-mystic-gold/60 -translate-x-[2px] -translate-y-[2px]" data-id="element-171"></div>
                <div className="absolute top-0 right-0 w-5 h-5 border-t-2 border-r-2 border-mystic-gold/60 translate-x-[2px] -translate-y-[2px]" data-id="element-172"></div>
                <div className="absolute bottom-0 left-0 w-5 h-5 border-b-2 border-l-2 border-mystic-gold/60 -translate-x-[2px] translate-y-[2px]" data-id="element-173"></div>
                <div className="absolute bottom-0 right-0 w-5 h-5 border-b-2 border-r-2 border-mystic-gold/60 translate-x-[2px] translate-y-[2px]" data-id="element-174"></div>

                <div className="flex flex-col items-center text-center h-full" data-id="element-175">
                  {/* Circular avatar */}
                  <motion.div initial={{
                scale: 0.8,
                opacity: 0
              }} whileInView={{
                scale: 1,
                opacity: 1
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.6,
                delay: 0.2 + idx * 0.15
              }} className="relative mb-8" data-id="element-176">
                    <div className="absolute -inset-2 rounded-full border border-mystic-gold/40 animate-flicker" data-id="element-177"></div>
                    <div className="absolute -inset-4 rounded-full border border-mystic-gold/20" data-id="element-178"></div>
                    <img src={t.image} alt={t.name} className="relative w-28 h-28 md:w-32 md:h-32 rounded-full object-cover border-2 border-mystic-gold/60 shadow-lg shadow-mystic-black" data-id="element-179" />
                  </motion.div>

                  {/* Stars */}
                  <div className="flex gap-1 mb-6 text-mystic-gold text-xl" data-id="element-180">
                    <span data-id="element-181">⭐</span>
                    <span data-id="element-182">⭐</span>
                    <span data-id="element-183">⭐</span>
                    <span data-id="element-184">⭐</span>
                    <span data-id="element-185">⭐</span>
                  </div>

                  {/* Quote */}
                  <blockquote className="space-y-5 text-lg md:text-xl text-mystic-ivorymuted italic leading-relaxed flex-grow" data-id="element-186">
                    <p data-id="element-187">
                      <span className="text-mystic-gold text-3xl font-serif leading-none mr-1" data-id="element-188">
                        "
                      </span>
                      {t.paragraphs[0]}
                    </p>
                    <p data-id="element-189">
                      {t.paragraphs[1]}
                      <span className="text-mystic-gold text-3xl font-serif leading-none ml-1" data-id="element-190">
                        "
                      </span>
                    </p>
                  </blockquote>

                  {/* Author */}
                  <div className="mt-8 flex items-center gap-4" data-id="element-191">
                    <div className="h-[1px] w-10 bg-mystic-gold/40" data-id="element-192"></div>
                    <p className="text-mystic-gold font-semibold tracking-wider uppercase text-sm" data-id="element-193">
                      {t.name}
                    </p>
                    <div className="h-[1px] w-10 bg-mystic-gold/40" data-id="element-194"></div>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* 🟣 CTA FINAL */}
      <section className="py-24 relative overflow-hidden" data-id="element-195">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-mystic-burgundy/20" data-id="element-196"></div>
        <div className="container mx-auto px-6 max-w-3xl text-center relative z-10" data-id="element-197">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={staggerContainer} data-id="element-198">
            <motion.h2 variants={fadeInUp} className="text-5xl md:text-6xl lg:text-7xl font-bold mb-10 text-gradient-gold" data-id="element-199">
              Las respuestas comienzan cuando decides escucharte.
            </motion.h2>

            <motion.div variants={fadeInUp} className="flex flex-col md:flex-row justify-center items-center gap-6 mb-12 text-xl text-mystic-ivorymuted" data-id="element-200">
              <span className="flex items-center gap-2" data-id="element-201">
                <span className="text-xl" data-id="element-202">🔮</span> Consulta espiritual
                personalizada online.
              </span>
              <span className="hidden md:inline text-mystic-gold/50" data-id="element-203">•</span>
              <span className="flex items-center gap-2" data-id="element-204">
                <span className="text-xl" data-id="element-205">✨</span> Lectura consciente del
                Tarot.
              </span>
              <span className="hidden md:inline text-mystic-gold/50" data-id="element-206">•</span>
              <span className="flex items-center gap-2" data-id="element-207">
                <span className="text-xl" data-id="element-208">🕯️</span> Atención privada vía
                WhatsApp.
              </span>
            </motion.div>

            <motion.p variants={fadeInUp} className="text-2xl md:text-3xl mb-10" data-id="element-209">
              👇 Da el primer paso hacia tu claridad emocional y espiritual.
            </motion.p>

            <motion.div variants={fadeInUp} data-id="element-210">
              <CtaButton text="QUIERO MI CONSULTA PERSONALIZADA" className="text-xl px-10 py-5" data-id="element-211" />
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 border-t border-mystic-gold/10 text-center text-mystic-ivorymuted/50 text-sm" data-id="element-212">
        <p data-id="element-213">
          © {new Date().getFullYear()} Salomón Rey del Amor. Todos los derechos
          reservados.
        </p>
      </footer>

      {/* Floating WhatsApp Button */}
      <FloatingWhatsApp data-id="element-214" />
    </div>;
}